<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>
<script>
import home from "./components/Home.vue";
import socketUtil from "./assets/js/websocketTools";
// import Backstage from "./components/AdminManage/Backstage";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {};
  },
  beforeCreate() {
    if (
      window.location.protocol.indexOf("https") === -1 &&
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "172.16.4.204" &&
      window.location.hostname !== "218.255.155.125"
    ) {
      const reUrl = window.location.href.replace("http://", "https://");
      window.location.href = reUrl;
    }
  },
  async created() {
    await this.checkOldUser();

    //this.initWebSocket();
    //获取localstorage中的登录信息
    // console.log(localStorage.getItem("userinfo").includes("null"));
    if (localStorage.getItem("userinfo") && !localStorage.getItem("userinfo").includes("null")) {
      this.$store.state.customer = JSON.parse(localStorage.getItem("userinfo"));
      if (
        this.$store.state.customer != null ||
        this.$store.state.customer != ""
      ) {
        this.$store.state.permission.Istoken = true;
        this.$store.state.permission.token =
          this.$store.state.customer.accessToken;
      }
    }
    //store数据持久化
    // 在页面加载时读取sessionStorage
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      // console.log(this.$store.state);
       if (this.verifyuserinfo() && this.$store.state.customer !== null) {
          localStorage.setItem("userinfo", JSON.stringify(this.$store.state.customer));
       }
    }

    if (!sessionStorage.length) {
      // 这个调用能触发目标事件，从而达到共享数据的目的
      localStorage.setItem("getSessionStorage", Date.now());
    }
    var self = this;

    // 该事件是核心
    window.addEventListener("storage", function (event) {
      if (event.key == "getSessionStorage") {
        // 已存在的标签页会收到这个事件
        localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
        // console.log('sessionStorage:', JSON.parse(sessionStorage.store));
        localStorage.removeItem("sessionStorage");
      }
      // else if (event.key == "sessionStorageData" && event.newValue !== null) {
      //   console.log(event.newValue);
      //   sessionStorage.setItem("store", event.newValue);
      //   sessionStorage.getItem("store") &&
      //     self.$store.replaceState(
      //       Object.assign(
      //         {},
      //         self.$store.state,
      //         JSON.parse(sessionStorage.getItem("store"))
      //       )
      //     );
      // }
      else if (event.key == "sessionStorage" && !sessionStorage.length) {
        // 新开启的标签页会收到这个事件
        // console.log(event);
        var data = JSON.parse(event.newValue),
          value;
        sessionStorage.setItem("store", data.store);
        // console.log('data.store:',JSON.parse(data.store));
        if(data.store == undefined || data.store == null || data.store == "") {
           sessionStorage.setItem("store", JSON.stringify(self.$store.state)); 
          //  console.log('666:',666);
        }
        sessionStorage.getItem("store") &&
          self.$store.replaceState(
            Object.assign(
              {},
              self.$store.state,
              JSON.parse(sessionStorage.getItem("store"))
            )
          );
          // console.log('self.$store.state:',self.$store.state);
      } 
    });

    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      // console.log('JSON.stringify(this.$store.state):',JSON.stringify(this.$store.state));
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    // console.log(this.$route.name == "adminIndex");
    if (this.$route.name !== "adminIndex") {
      // socketUtil.initWebsocket(0);
    }
    this.writeTvcategory();
    // this.langToggle();
  },
  components: {
    Home: home,
    // Backstage:Backstage
  },
  methods: {
    verifyuserinfo(){
      return !localStorage.getItem("userinfo") || localStorage.getItem("userinfo").includes("null");
    },
    async checkOldUser() {
      /* this.setCookie(
        "Yisitant",
        `iUser=Muji&iMail=callis.lee@icloud.com&iDisplay=Muji&Credits=10&UID=234349&AStatus=101&LMatch=0&NWfxd=1024&DAct=False&FrExe=False&Aban=550`,
        9999
      ); */
      //判断是否有cookie
      const cookieStr = this.getCookie("Yisitant");
      if (cookieStr !== "") {
        //获取UID，iMail
        const uid = this.getCookiePar(cookieStr, "UID");
        const iMail = this.getCookiePar(cookieStr, "iMail");
        if (uid !== "" && iMail !== "") {
          let result = await this.$api.common.oldLogin({
            uid,
            userNameOrEmailAddress: iMail,
          });
          // console.log(result);
          if (result.data.success) {
            this.$store.commit("writecustomer", result.data.result);
            this.$store.commit("updatePermission", result);
            // console.log(this.$store.state);
            sessionStorage.setItem("store", JSON.stringify(this.$store.state));
            localStorage.setItem(
              "userinfo",
              JSON.stringify(this.$store.getters.getcustomer)
            );
            this.clearCookie("Yisitant");
          }
        }
      }
    },
    // langToggle(){
    //   if(this.$i18n.locale == 'zh'){
    //     this.$i18n.locale = 'en';
    //   }else{
    //     this.$i18n.locale = 'zh';
    //   }
    // }, 
    //把节目分类数据写入store
    writeTvcategory() {
      let params = { SGL_Program_Type: 0, SkipCount: 0, MaxResultCount: 50 };
      this.$api.VideoApi.GetProgramList(params).then((result) => {
        if (result.data.success) {
          let data = result.data.result.items;
          this.$store.dispatch("writeTvcategory", data);
        } else {
          this.$message({
            type: "error",
            message: result.data.error.message,
          });
        }
      });
      //将影片分类写入store
      let param = { Sorting: "1", SkipCount: 0, MaxResultCount: 50 };
      this.$api.VideoApi.GetMovieTypeList(param).then((res) => {
        //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>
        if (res.data.success) {
          let data = res.data.result.items;
          this.$store.dispatch("writeVideoCategory", data);
        } else {
          this.$message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue